import api from "api/api";

export const getExchangeRateList = async (page, limit) =>
  await api.get(`/settings/convertionrate?page=${page}&limit=${limit}`);

export const getExchangeRateById = async (id) =>
  await api.get(`/settings/convertionrate/${id}`);

export const deleteExchangeRateById = async (id) =>
  await api.delete(`/settings/convertionrate/${id}`);

export const updateExchangeRateById = async (id, data) =>
  await api.put(`/settings/convertionrate/${id}`, data);

export const createExchangeRate = async (data) =>
  await api.post("/settings/convertionrate", data);

export const uploadExchangeRateQuery = async (id, file) =>
  await api.putFile(`/settings/convertionrate/import?country_id=${id}`, file);
